"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _roleHash = require("./role-hash");
Object.keys(_roleHash).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _roleHash[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _roleHash[key];
    }
  });
});
var _defaultAddress = require("./default-address");
Object.keys(_defaultAddress).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _defaultAddress[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _defaultAddress[key];
    }
  });
});
var _contractAddress = require("./contract-address");
Object.keys(_contractAddress).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _contractAddress[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _contractAddress[key];
    }
  });
});
var _contractInterfaceId = require("./contract-interface-id");
Object.keys(_contractInterfaceId).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _contractInterfaceId[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _contractInterfaceId[key];
    }
  });
});